<template>
  <section class="shoppingMall">
    <header-com isTransparent />
    <!--头图-->
    <div class="topImg">
      <img v-if='topImage'
           v-bind:src="topImage.split('?')[0]">
    </div>

    <!--上新专区-->
    <section class="newProWrap">
      <div class="date">
        <div class="content">{{timeDay}}</div><span>日</span>
      </div>
      <swiper :options="timeViewOption"
              class="timeSwiper">
        <swiper-slide v-for="(item,index) in timeList"
                      :key="index"
                      v-bind:class="[index==timeListIndex?'timeItemActive':item.timeStr<nowTimeStr?'timeItem':'timeItem timeItemGray']"
                      @click.native="timeClick(index,item.sellTimeMinute)">{{item.time}}<span v-if="index==timeListIndex"></span></swiper-slide>
      </swiper>

      <div>
        <ul class="proList p40">
          <li v-for="(item,index) in newTopList"
              :key="index">
            <div v-if='timeList[timeListIndex].timeStr>nowTimeStr'
                 @click.stop="remindClick(item.id,item.isPanicBuyNotice,index)"
                 v-bind:class="[!item.isPanicBuyNotice?'remind remindActive':'remind remindGray']"></div>
            <pro-info-card :item="item" :isTopNew="true" />
          </li>
        </ul>
      </div>

    </section>

  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import homeApi from "@api/home";
import CollectCom from "../../../components/collectCom";
import { Toast } from 'vant';
export default {
  name: "index",
  components: { CollectCom },
  data() {
    // const _this = this
    return {
      //现在时间的时间戳
      nowTimeStr: new Date().getTime(),
      //上新列表
      newTopList: [],
      //上新头图
      topImage: '',
      //上新时间轴
      timeList: [],
      timeListIndex: 0,
      timeDay: '',
      swiperOption: {
        loop: true,
        spaceBetween: 6,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination"
          // type: 'progressbar',
        },
        on: {
          tap: () => {
            const item = this.bannerList[this.mySwiper.realIndex];
            // console.log(realIndex)
            this.$router.push({
              name: item.pathName,
              params: { id: item.params }
            });
          }
        }
      },
      bannerList: [
        { pathName: "sceneDetailProcess", bannerPic: "banner_01.png" },
        { pathName: "sceneDetail", bannerPic: "newbanner02.jpg", params: 1 },
        { pathName: "sceneDetail", bannerPic: "newbanner03.jpg", params: 2 }
      ],

      //上新专区时间
      timeViewOption: {
        slidesPerView: "auto",
        spaceBetween: 20,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20
      },

    };
  },
  computed: {
    ...mapState({
      // categoryList:state => state.attributes.categoryList,
      saleTypeObj: "saleTypeObj",
      serviceObj: "serviceObj"
    }),
    mySwiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    //诸葛：首页-进入二级页面
    zhuge.track("首页-进入二级页面", { 
          "二级页面名称":"上新专区",
          "二级页面导航名称":location.href
        });
  },
  mounted() { 
  },
  activated() {
    this.getTopNew();
  },
  methods: {
    ...mapActions({
      addViewHistory: "user/addViewHistory"
    }),

    getTopNew(params = {}) {
      homeApi.getTopNew(params).then(res => {
        if(res){
          if (!params.selectedPresaleTime) {
          let data = res.dailyNewPresaleTimeDTOS
          for (let i = 0; i < data.length; i++) {
            let timeArr = data[i].sellTimeMinute.split(" ")[1].split(":")
            let time = timeArr[0] + ":" + timeArr[1]
            data[i].time = time
            data[i].timeStr = new Date(data[i].sellTimeMinute.replace(/-/g, "/")).getTime()
            if (data[i].sellTimeMinute == res.selectedPresaleTime) {
              this.timeListIndex = i
            }
          }
          this.timeList = data
        }
        let dateArr = (res.sellTimeDay.split(" ")[0]).split("-")
        this.timeDay = dateArr[1] + "." + dateArr[2]
        this.newTopList = res.productDTOS
        this.topImage = res.image
        }else{
          this.$router.back()
        }
      })

    },
    // 点击铃铛（提醒）
    remindClick(id, isRemind, index) {
      if (isRemind) {
        Toast('已添加提醒')
      } else {
        homeApi.remind({
          type: 2,
          productSku: id
        }).then(res => {
          //诸葛：开抢提醒
          let proDetail=this.newTopList[index];
          zhuge.track("开抢提醒", { 
            "商品名称":proDetail.brandNameEn+' '+proDetail.name+' '+proDetail.categoryName,
            "品牌":proDetail.brandNameEn,
            "价格":proDetail.price,
            "商品等级":proDetail.attributes[0].value
          });
          this.newTopList[index].isPanicBuyNotice = true
          Toast('成功添加提醒')
        })
      }

    },
    //上新专区时间点击
    timeClick(index, sellTimeMinute) {
      this.timeListIndex = index
      this.getTopNew({ selectedPresaleTime: sellTimeMinute })
    },

    toggleCollect($event, item) {
      item.isCollect = $event;
    }
  }
};
</script>

<style lang="scss" scoped>
.shoppingMall {
  padding: 0 0 170px;
  /*轮播图*/
  .topImg {
    width: 100%;
    height: 420px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  /*最新上架*/
  .newProWrap {
    position: relative;
    .banner {
      height: 400px;
      img {
        width: 100%;
        height: 100%;
        /*<!--background: $brand-color;-->*/
        border-radius: 10px;
      }
    }
    .date {
        position: absolute;
        width: 100px;
        height: 36px;
        left: 40px;
        line-height: 36px;
        background: url("/images/home/orange_date.png") no-repeat;
        text-align: center;
        font-size: 24px;
        color: white;
        z-index: 9;
        background-size: contain;
        font-weight: 500;
        padding-left: 8px;
        overflow: hidden;
        .content {
          float: left;
          font-size: 24px;
        }
        span {
          width: 20px;
          display: block;
          float: left;
          margin-top: 2px;
          -webkit-transform: scale(0.7);
        }
      }

    // 	上新专区时间轴
    .timeSwiper {
      height: 46px;
      margin: 48px 0 32px 40px;
      box-sizing: border-box;
      padding-left: 100px;
      overflow: hidden;
      .timeItem {
        width: 70px;
        height: 46px;
        line-height: 32px;
        font-size: 28px;
        color: #000;
      }
      .timeItemGray {
        color: #999999;
      }
      .timeItemActive {
        width: 80px;
        height: 46px;
        font-size: 32px;
        line-height: 32px;
        color: #000;
        font-weight: bold;
        span {
          width: 48px;
          height: 8px;
          display: block;
          margin: 6px auto 0;
          border-radius: 4px;
          background-color: #fd946c;
        }
      }
    }

    .proList {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 308px;
        position: relative;
      }
      .remind {
        width: 36px;
        height: 36px;
        position: absolute;
        z-index: 9;
        right: 0;
        top: 416px;
      }
      .remindActive {
        background: url("/images/home/orange_smallBell.png") no-repeat;
        background-size: contain;
      }
      .remindGray {
        background: url("/images/home/gray_smallBell.png") no-repeat;
        background-size: contain;
      }
    }
  }
}
</style>

<style lang="scss">
.shoppingMall {
  .swiper-pagination-bullet {
    width: 16px;
    height: 12px;
    background: rgba($white-color, 0.6);
    border-radius: 6px;
    transition: 0.3s;
  }
  .swiper-pagination-bullet-active {
    width: 40px;
    background: rgba($white-color, 0.6);
  }
}
</style>
